export default "__VITE_ASSET__DfBR8aHV__"